<script>
import layout from '@src/mixins/layout.vue'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
import store from '@state/store'
import { chatComputed } from '@/src/state/chatHelper'
import { providerChatService } from '@/src/services/safehaven/ProviderChatService'

export default {
  mixins: [layout, NavigateMixin],
  data() {
    return {
      dialog: true,
      chatMessage: '',
      messages: [],
      messageForm: {
        content: '',
        me: true,
        contentType: '',
      },
      file: null,
    }
  },
  computed: {
    ...chatComputed,
    cardStyle() {
      return this.mobile
        ? this.$style.mobilechatContainer
        : this.$style.chatContainer
    },
  },
  watch: {
    chatMessages(newValue) {
      this.messages = []
      this.messages.push(newValue)
      this.$nextTick(function() {
        var container = this.$refs.messageSection
        container.scrollTo({
          top: container.scrollHeight + 120,
          behavior: 'smooth',
        })
      })
    },
  },
  methods: {
    sendMessage(msg) {
      if (msg && !/^\s*$/.test(msg)) {
        const data = {
          content: msg,
          me: true,
          contentType: 'text/plain',
        }
        this.messages.push(data)
        store.dispatch('chat/setChatMessage', data)
        providerChatService.sendMessage(data)
        var element = document.getElementById('msgContainer')
        element.scrollIntoView({ behavior: 'smooth', block: 'end' })
        this.chatMessage = ''
      }
    },
    onFileChange(file) {
      const data = {
        content: file.name,
        me: true,
        contentType: file.type,
      }
      if (file.size <= 32000) {
        this.send32KbBase64(data, file)
      } else if (file.size > 32000 && file.size <= 5242880) {
        this.send5Mbfile(file)
      } else {
        data.content = file.name + ' exceeds file size of 5MB'
        this.messages.push(data)
        store.dispatch('chat/setChatMessage', data)
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    },
    send32KbBase64(data, file) {
      const baseFile = this.getBase64(file)
      baseFile.then((res) => {
        const fileData = {
          content: res,
          contentType: file.type,
          chunkId: 'NA',
          fileName: data.content,
          chunkSize: 'NA',
          isEOF: true,
        }
        this.messages.push(data)
        store.dispatch('chat/setChatMessage', data)
        providerChatService.sendMessage(fileData)
      })
    },
    send5Mbfile(file) {
      const fileData = {
        content: file,
        me: true,
        contentType: file.type,
      }
      providerChatService.sendMessage(fileData)
    },
  },
}
</script>

<template>
  <div>
    <v-list height="70">
      <template>
        <v-list-item style="bottom: 6px">
          <v-list-item-avatar height="66" width="68">
            <v-img
              :src="require('@assets/images/safehaven/Dashboard-Yoga@2x.png')"
              contain
            />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title style="color: #09101d">{{
              $store.state.chat.patientProviderDetails.provider_name
            }}</v-list-item-title>
            <v-list-item-subtitle style="color: #09101d">{{
              $store.state.chat.patientProviderDetails.provider_type
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>

    <v-card-text ref="messageSection" :class="cardStyle">
      <v-row no-gutters>
        <v-col>
          <div
            v-for="(msg, index) in $store.state.chat.message"
            :key="index"
            :align="msg.me ? 'right' : 'left'"
            :class="{ 'd-flex flex-row-reverse': msg.me }"
          >
            <div
              :class="
                msg.me
                  ? msg &&
                    msg.content &&
                    msg.content.includes('exceeds file size')
                    ? $style.ownChatContainer + ' ' + $style.bgRed
                    : $style.ownChatContainer
                  : $style.providerChatContainer
              "
            >
              <div
                v-if="msg.contentType !== 'text/plain'"
                :class="$style.imgClass"
              >
                <v-img
                  :src="require('@assets/images/safehaven/file_present.svg')"
                  height="30"
                  width="40"
                ></v-img>
              </div>
              <div
                :class="
                  msg.contentType !== 'text/plain'
                    ? [$style.imgClass, $style.w75]
                    : $style.w100
                "
              >
                {{ msg.content }}
              </div>
            </div>
          </div>
          <div align="right">
            <div
              v-if="$store.state.chat.loading"
              :class="$style.ownChatContainer"
            >
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
              Sending attachment
            </div>
          </div>
        </v-col>
      </v-row>

      <div id="msgContainer" style="padding: 30px"></div>
    </v-card-text>

    <v-card-actions class="pa-0">
      <v-footer width="100%" :class="$style.footerContainer" dense>
        <v-row no-gutter>
          <v-col cols="1" :class="$style.p0">
            <v-file-input
              file-size
              append-icon="mdi-paperclip"
              class="uploadDoc"
              :disabled="
                $store.state.chat.loading || !$store.state.chat.chatConnected
              "
              @change="onFileChange($event)"
            >
            </v-file-input>
          </v-col>
          <v-col cols="11" :class="$style.p0">
            <v-textarea
              v-model="chatMessage"
              dense
              class="pa-0"
              label="Your Message"
              type="text"
              solo
              no-details
              hide-details
              no-resize
              rows="1"
              :disabled="!$store.state.chat.chatConnected"
              :class="$style.textAreaContainer"
              @keyup.enter="sendMessage(chatMessage)"
            >
              <template v-slot:append-outer :class="$style.sendIconContainer">
                <v-icon
                  :class="
                    chatMessage !== ''
                      ? $style.sendIcon
                      : $style.sendIconDisable
                  "
                  @click="sendMessage(chatMessage)"
                  >mdi-send</v-icon
                >
              </template>
            </v-textarea>
          </v-col>
        </v-row>
      </v-footer>
    </v-card-actions>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.v-dialog:not(.v-dialog--fullscreen) {
  height: 80vh !important;
  overflow: hidden;
}

.sendIcon {
  position: absolute !important;
  right: 10px;
  color: #0476d9 !important;
  cursor: pointer;
}

.imgClass {
  display: inline-block;
}

.w100 {
  width: 100%;
}

.w75 {
  width: 75%;
  word-wrap: break-word !important;
}

.sendIconDisable {
  position: absolute !important;
  right: 10px;
  cursor: pointer;
}

.sendIconContainer {
  position: absolute;
  right: 12px;
}

.p0 {
  display: inline-grid;
  padding: 5px !important;
}

.ownChatContainer {
  top: 337px;
  right: 13px;
  width: fit-content !important;
  max-width: 80% !important;
  padding: 10px;
  padding-bottom: 5px;
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: #fff;
  text-align: left;
  white-space: normal;
  background: #0476d9;
  border: 1px solid #f4f6f9;
  border-radius: 7px;
  box-shadow: 1px 3px 5px rgba(4, 118, 217, 0.3);
}

.providerChatContainer {
  top: 188px;
  right: 13px;
  width: fit-content !important;
  max-width: 80% !important;
  padding: 10px;
  padding-bottom: 5px;
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: #000;
  text-align: left;
  white-space: normal;
  background: #fff;
  border: 1px solid #f4f6f9;
  border-radius: 7px;
  box-shadow: 1px 3px 5px rgba(4, 118, 217, 0.3);
}

.bgRed {
  background: #d90404;
  border: 1px solid #d90404;
}

.endSecureChatText {
  font-size: 15px;
  font-weight: 400;
  color: #0476d9;
  letter-spacing: 0;
}

.chatContainer {
  height: 65vh;
  overflow-y: scroll;
}

.mobilechatContainer {
  height: 100%;
  overflow-y: scroll;
}

.footerContainer {
  position: absolute !important;
  right: 0;
  bottom: 14px;
  left: 0;
  padding: 10px 15px 0 15px;
  background-color: #f2f9ff !important;
}

.attachmentIcon {
  font-size: 35px !important;
}

.textAreaContainer {
  padding: 0;
  margin-right: 15px;
  background: #fff;
  border: 0.8px solid #a5abb3;
  border-radius: 5px;
}

.textAreaContainer:disabled {
  pointer-events: visible !important;
  cursor: not-allowed !important;
}

@media screen and (min-width: 600px) and (max-width: 1280px) {
  .footerContainer {
    position: relative !important;
    bottom: 15px !important;
    background-color: #f2f9ff !important;
  }

  .chatContainer {
    overflow-y: scroll;
    background-color: #f2f9ff !important;
  }
}

@media screen and (max-width: 599px) {
  .footerContainer {
    position: fixed !important;
    bottom: 15px !important;
    background-color: #f2f9ff !important;
  }
}
</style>
